export default __webpack_public_path__ + "static/media/light-play-icon.d5d99b66.svg";